module.exports = __webpack_public_path__ + "img/jfy.857fbaf8.png";